import Empty from 'constants/empty';

/**
 * FER-819 — Automated (Constructor.io) bundle data path.
 *
 * Transforms a PRS GraphQL `ProductRecommendations` response into the same
 * bundle-product-list shape the manual path (FER-818) produces, so downstream
 * rendering (FER-791) can consume either source interchangeably.
 */

const CHANGE_OPTION_NOUN = {
    COLOR: 'Color',
    SCENT: 'Scent'
};

const DEFAULT_CHANGE_OPTION_NOUN = 'Option';

export const getChangeOptionNoun = variationType => {
    const normalized = variationType?.toUpperCase();

    if (!normalized) {
        return DEFAULT_CHANGE_OPTION_NOUN;
    }

    // AC-3c: any SIZE / SIZE_* combination maps to "Size".
    if (normalized.startsWith('SIZE')) {
        return 'Size';
    }

    return CHANGE_OPTION_NOUN[normalized] || DEFAULT_CHANGE_OPTION_NOUN;
};

const PRICE_TYPE = {
    LIST: 'LIST',
    SALE: 'SALE'
};

const getFormattedPrice = (skuPrices, type) => {
    const match = skuPrices.find(skuPrice => skuPrice?.type === type);

    return match?.price != null ? `$${Number(match.price).toFixed(2)}` : undefined;
};

const buildBundleProduct = result => {
    const product = result?.product;

    if (!product?.productId) {
        return null;
    }

    const { currentSku = Empty.Object, variationType } = product;
    const skuPrices = currentSku.skuPrices || Empty.Array;

    const listPrice = getFormattedPrice(skuPrices, PRICE_TYPE.LIST);
    const salePrice = getFormattedPrice(skuPrices, PRICE_TYPE.SALE);

    return {
        productId: product.productId,
        skuId: currentSku.skuId,
        brandName: product.brandName,
        productName: product.name,
        url: product.url,
        skuImages: currentSku.skuImages || { imageUrl: product.imageUrl },
        variationValue: currentSku.variationValue,
        // AC-3: store the mapped noun so FER-791 renders "Change <noun>".
        variationType: variationType ? getChangeOptionNoun(variationType) : undefined,
        listPrice,
        salePrice
    };
};

/**
 * @param {object} response - the `recommendations` payload from getProductRecommendations.
 * @returns {Array} bundle products in manual-path format (empty on missing/empty results).
 */
const buildBundleProducts = response => {
    const results = response?.response?.results;

    if (!Array.isArray(results) || !results.length) {
        return Empty.Array;
    }

    return results.map(buildBundleProduct).filter(Boolean);
};

export default buildBundleProducts;
